export default "__VITE_ASSET__CkFfpaDr__"